export const AFTER_FOOTER = "after-footer"
